import { TGlobalConfigContextState } from './GlobalConfigContext';

export const globalConfigSelectors = {
  currentEmail: (state: TGlobalConfigContextState) => {
    return state.currentEmail;
  },
  userData: (state: TGlobalConfigContextState) => {
    return state.userData;
  },
  jobPostIdToActive: (state: TGlobalConfigContextState) => {
    return state.jobPostIdToActive;
  },
  jobPostIdToDelete: (state: TGlobalConfigContextState) => {
    return state.jobPostIdToDelete;
  },
  isReady: (state: TGlobalConfigContextState) => {
    return state.isReady;
  },
  isShowMatchScore: (state: TGlobalConfigContextState) => {
    return state.isShowMatchScore;
  },
  isOpenDeleteJobPostModal: (state: TGlobalConfigContextState) => {
    return state.isOpenDeleteJobPostModal;
  },
  isOpenMoveJobPostToDraftModal: (state: TGlobalConfigContextState) => {
    return state.isOpenMoveJobPostToDraftModal;
  },
  jobPostIdToDraft: (state: TGlobalConfigContextState) => {
    return state.jobPostIdToDraft;
  },
  isOpenMoveJobPostToActiveModal: (state: TGlobalConfigContextState) => {
    return state.isOpenMoveJobPostToActiveModal;
  },
  isOpenRecruiterStartConversationModal: (state: TGlobalConfigContextState) => {
    return state.isOpenRecruiterStartConversationModal;
  },
  isOpenRecruiterDenyCandidateModal: (state: TGlobalConfigContextState) => {
    return state.isOpenRecruiterDenyCandidateModal;
  },
  isOpenRecruiterApproveCandidateModal: (state: TGlobalConfigContextState) => {
    return state.isOpenRecruiterApproveCandidateModal;
  },
  isOpenOnboardingWizard: (state: TGlobalConfigContextState) => {
    return state.isOpenOnboardingWizard;
  },
  messages: (state: TGlobalConfigContextState) => {
    return state.messages;
  },
  profileNotificationsData: (state: TGlobalConfigContextState) => {
    return state.profileNotificationsData;
  },
  unreadNotificationsCount: (state: TGlobalConfigContextState) => {
    return state.unreadNotificationsCount;
  },
  hasUnreadMessages: (state: TGlobalConfigContextState) => {
    return state.hasUnreadMessages;
  },
  update: (state: TGlobalConfigContextState) => {
    return state.update;
  },
};
